import * as actions from './actions';
//import _ from 'lodash';

/*
//Temporary
let studies = [
    { "id": "NCT03958955", "studyId": "EXP-1373|2018-003615-22", "title": "Efficacy and Safety of Delgocitinib Cream in Discoid Lupus Erythematosus.", "enrollment": 27, "completionDate": "2020-04-30T00:00:00", "primaryCompletionDate": "2020-04-15T00:00:00", "results_first_submitted_date": "2021-06-28T00:00:00", "study_first_submitted_date": "2019-05-22T00:00:00", "startDate": "2019-07-09T00:00:00", "duration": 296, "study_phase": "Phase 2", "sponsor_collaborators": ["LEO Pharma"], "condition": ["Discoid Lupus Erythematosus"], "outcomes": ["Target Lesions With Investigator's Global Assessment (IGA) Score of 0 (Clear) or 1 (Almost Clear) at Week 6.", "Number of Adverse Events (AEs) up to Week 6.", "Number of Subjects With AEs up to Week 6.", "Number of Lesion-specific, Treatment-related AEs up to Week 6.", "Number of Lesions With ≥2-point Reduction in IGA Score at Week 6 Compared to Baseline.", "Number of Lesions With ≥2-point Reduction in Erythema Score at Week 6 Compared to Baseline.", "Erythema Score at Week 6.", "Total Skin Disease Activity Score (Sum of Scores for Erythema, Scaling/Hyperkeratosis, and Oedema/Infiltration) at Week 6."], "interventions": ["Drug: Delgocitinib cream", "Drug: Delgocitinib cream vehicle"], "meta_prim_outcome": "", "meta_time_frame": "" },
    { "id": "NCT04871711", "studyId": "LP0133-1401|2020-002960-30", "title": "Efficacy and Safety of Delgocitinib Cream in Adults With Moderate to Severe Chronic Hand Eczema", "enrollment": 487, "completionDate": "2022-10-26T00:00:00", "primaryCompletionDate": "2022-10-12T00:00:00", "results_first_submitted_date": null, "study_first_submitted_date": "2021-05-04T00:00:00", "startDate": "2021-05-10T00:00:00", "duration": 534, "study_phase": "Phase 3", "sponsor_collaborators": ["LEO Pharma"], "condition": ["Chronic Hand Eczema"], "outcomes": ["IGA-CHE TS at Week 16", "Reduction of HESD itch score (weekly average) of ≥4 points from baseline at Week 16", "Reduction of HESD score (weekly average) of ≥4 points from baseline at Week 16", "IGA-CHE TS at Week 8", "IGA-CHE TS at Week 4", "Reduction of HESD itch score (weekly average) of ≥4 points from baseline at Week 8", "Reduction of HESD itch score (weekly average) of ≥4 points from baseline at Week 4", "Reduction of HESD itch score (weekly average) of ≥4 points from baseline at Week 2", "Reduction of HESD score (weekly average) of ≥4 points from baseline at Week 8", "Reduction of HESD score (weekly average) of ≥4 points from baseline at Week 4", "Reduction of HESD pain score (weekly average) of ≥4 points from baseline at Week 16", "Reduction of HESD pain score (weekly average) of ≥4 points from baseline at Week 8", "Reduction of HESD pain score (weekly average) of ≥4 points from baseline at Week 4", "HECSI-90 at Week 16", "HECSI-75 at Week 16", "HECSI-75 at Week 8", "Percentage change in HECSI score from baseline to Week 16", "Change in DLQI score from baseline to Week 16", "Change in HESD score (weekly average) from baseline to Week 16", "Change in HESD itch score (weekly average) from baseline to Week 16", "Change in HESD pain score (weekly average) from baseline to Week 16", "Change in HEIS score from baseline to Week 16", "Change in HEIS PDAL score from baseline to Week 16", "Reduction of DLQI score of ≥4 points from baseline at Week 16", "Number of treatment-emergent AEs from baseline up to end of trial per participant"], "interventions": ["Drug: Delgocitinib cream", "Drug: Cream vehicle"], "meta_prim_outcome": "", "meta_time_frame": "" },
    { "id": "NCT04872101", "studyId": "LP0133-1402|2020-002961-32", "title": "Efficacy and Safety of Delgocitinib Cream in Adults With Moderate to Severe Chronic Hand Eczema (DELTA 2)", "enrollment": 450, "completionDate": "2023-01-04T00:00:00", "primaryCompletionDate": "2022-12-19T00:00:00", "results_first_submitted_date": null, "study_first_submitted_date": "2021-05-04T00:00:00", "startDate": "2021-05-25T00:00:00", "duration": 589, "study_phase": "Phase 3", "sponsor_collaborators": ["LEO Pharma"], "condition": ["Chronic Hand Eczema"], "outcomes": ["IGA-CHE TS at Week 16", "Reduction of HESD itch score (weekly average) of ≥4 points from baseline at Week 16", "Reduction of HESD score (weekly average) of ≥4 points from baseline at Week 16", "IGA-CHE TS at Week 8", "IGA-CHE TS at Week 4", "Reduction of HESD itch score (weekly average) of ≥4 points from baseline at Week 8", "Reduction of HESD itch score (weekly average) of ≥4 points from baseline at Week 4", "Reduction of HESD itch score (weekly average) of ≥4 points from baseline at Week 2", "Reduction of HESD score (weekly average) of ≥4 points from baseline at Week 8", "Reduction of HESD score (weekly average) of ≥4 points from baseline at Week 4", "Reduction of HESD pain score (weekly average) of ≥4 points from baseline at Week 16", "Reduction of HESD pain score (weekly average) of ≥4 points from baseline at Week 8", "Reduction of HESD pain score (weekly average) of ≥4 points from baseline at Week 4", "HECSI-90 at Week 16", "HECSI-75 at Week 16", "HECSI-75 at Week 8", "Percentage change in HECSI score from baseline to Week 16", "Change in DLQI score from baseline to Week 16", "Change in HESD score (weekly average) from baseline to Week 16", "Change in HESD itch score (weekly average) from baseline to Week 16", "Change in HESD pain score (weekly average) from baseline to Week 16", "Change in HEIS score from baseline to Week 16", "Change in HEIS PDAL score from baseline to Week 16", "Reduction of DLQI score of ≥4 points from baseline at Week 16", "Number of treatment-emergent AEs from baseline up to end of trial per participant"], "interventions": ["Drug: Delgocitinib cream", "Drug: Cream vehicle"], "meta_prim_outcome": "", "meta_time_frame": "" },
    { "id": "NCT05355818", "studyId": "LP0133-1426|2021-006340-27", "title": "Efficacy and Safety of Delgocitinib Cream in Adolescents 12-17 Years of Age With Moderate to Severe Chronic Hand Eczema", "enrollment": 92, "completionDate": "2023-12-15T00:00:00", "primaryCompletionDate": "2023-12-01T00:00:00", "results_first_submitted_date": null, "study_first_submitted_date": "2022-05-02T00:00:00", "startDate": "2022-07-14T00:00:00", "duration": 519, "study_phase": "Phase 3", "sponsor_collaborators": ["LEO Pharma"], "condition": ["Chronic Hand Eczema"], "outcomes": ["IGA-CHE treatment success at Week 16", "HECSI-90 at Week 16", "Reduction of HESD itch score (weekly average) of ≥4 points from baseline at Week 16", "Reduction of HESD pain score (weekly average) of ≥4 points from baseline at Week 16", "Reduction of HESD score (weekly average) of ≥4 points from baseline at Week 16", "IGA-CHE treatment success at Week 2", "IGA-CHE treatment success at Week 4", "IGA-CHE treatment success at Week 8", "IGA-CHE treatment success at Week 12", "Change in cDLQI score from baseline to Week 16", "Number of treatment emergent AEs from baseline up to Week 18"], "interventions": ["Drug: Delgocitinib", "Drug: Cream vehicle"], "meta_prim_outcome": "", "meta_time_frame": "" },
    { "id": "NCT05332366", "studyId": "EXP-2228", "title": "A Trial to Assess the Effect of Delgocitinib Cream 20 mg/g on the Molecular Signature, Safety, and Efficacy in Adults With Frontal Fibrosing Alopecia", "enrollment": 35, "completionDate": "2023-06-15T00:00:00", "primaryCompletionDate": "2023-03-09T00:00:00", "results_first_submitted_date": null, "study_first_submitted_date": "2022-04-18T00:00:00", "startDate": "2022-04-19T00:00:00", "duration": 422, "study_phase": "Phase 2", "sponsor_collaborators": ["LEO Pharma"], "condition": ["Frontal Fibrosing Alopecia"], "outcomes": ["Change in expression of chemokine (C-X-C motif) ligand 9 (CXCL9), chemokine (C-X-C motif) ligand 10 (CXCL10), and interferon (IFN)-γ from baseline to Week 12.", "Number of treatment-emergent adverse events (TEAEs) from baseline to Week 12."], "interventions": ["Drug: Delgocitinib cream", "Drug: Delgocitinib cream vehicle"], "meta_prim_outcome": "", "meta_time_frame": "" },
    { "id": "NCT05259722", "studyId": "LP0133-1528|2021-003543-16", "title": "A 24 Week Trial to Compare the Efficacy and Safety of Delgocitinib Cream 20 mg/g Twice-daily With Alitretinoin Capsules Once-daily in Adult Participants With Severe Chronic Hand Eczema", "enrollment": 510, "completionDate": "2023-10-31T00:00:00", "primaryCompletionDate": "2023-07-25T00:00:00", "results_first_submitted_date": null, "study_first_submitted_date": "2022-02-28T00:00:00", "startDate": "2022-06-15T00:00:00", "duration": 503, "study_phase": "Phase 3", "sponsor_collaborators": ["LEO Pharma"], "condition": ["Chronic Hand Eczema"], "outcomes": ["Change in HECSI score from baseline to Week 12", "HECSI-90 at Week 12", "IGA-CHE TS at Week 12.", "Change in HESD itch score (weekly average) from baseline to Week 12", "Change in HESD pain score (weekly average) from baseline to Week 12.", "AUC of HECSI-90 from baseline up to Week 24", "AUC of change from baseline in DLQI score up to Week 24", "Change in HECSI score from baseline to Week 24", "Number of treatment-emergent AEs from baseline up to Week 26", "Number of treatment-emergent SAEs from baseline up to Week 26", "Number of AEs leading to IMP discontinuation up to Week 24"], "interventions": ["Drug: Delgocitinib", "Drug: Toctino"], "meta_prim_outcome": "", "meta_time_frame": "" },
    { "id": "NCT03725722", "studyId": "LP0133-1275", "title": "Dose-ranging Trial to Evaluate Delgocitinib Cream 1, 3, 8, and 20 mg/g Compared to Delgocitinib Cream Vehicle Over an 8-week Treatment Period in Adult Subjects With Atopic Dermatitis.", "enrollment": 251, "completionDate": "2020-05-19T00:00:00", "primaryCompletionDate": "2020-05-19T00:00:00", "results_first_submitted_date": "2021-07-08T00:00:00", "study_first_submitted_date": "2018-10-31T00:00:00", "startDate": "2018-12-28T00:00:00", "duration": 508, "study_phase": "Phase 2", "sponsor_collaborators": ["LEO Pharma"], "condition": ["Atopic Dermatitis"], "outcomes": ["Change From Baseline (Week 0) to Week 8 in Eczema Area and Severity Index (EASI) Score.", "Validated Investigator Global Assessment Scale for Atopic Dermatitis (vIGA-AD) Score of 0 (Clear) or 1 (Almost Clear) With ≥2-step Improvement (vIGA-AD TS) From Baseline to Week 8.", "EASI75 at Week 8", "Time to vIGA-AD TS"], "interventions": ["Drug: Delgocitinib cream", "Drug: Delgocitinib cream vehicle"], "meta_prim_outcome": "", "meta_time_frame": "" },
    { "id": "NCT03683719", "studyId": "LP0133-1273", "title": "Phase 2b Dose-ranging Trial to Evaluate Delgocitinib Cream 1, 3, 8, and 20 mg/g Compared to Delgocitinib Cream Vehicle Over a 16-week Treatment Period in Adult Subjects With Chronic Hand Eczema", "enrollment": 258, "completionDate": "2020-04-20T00:00:00", "primaryCompletionDate": "2020-03-06T00:00:00", "results_first_submitted_date": "2021-04-19T00:00:00", "study_first_submitted_date": "2018-09-25T00:00:00", "startDate": "2018-11-28T00:00:00", "duration": 509, "study_phase": "Phase 2", "sponsor_collaborators": ["LEO Pharma"], "condition": ["Chronic Hand Eczema"], "outcomes": ["Investigator's Global Assessment for Chronic Hand Eczema (IGA-CHE) Score of 0 (Clear) or 1 (Almost Clear) With at Least a 2-step Improvement (IGA-CHE Treatment Success) From Baseline to Week 16.", "Change in Hand Eczema Severity Index (HECSI) From Baseline to Week 16.", "Time to IGA-CHE Treatment Success."], "interventions": ["Drug: Delgocitinib cream", "Drug: Delgocitinib cream vehicle"], "meta_prim_outcome": "", "meta_time_frame": "" },
    { "id": "NCT04949841", "studyId": "LP0133-1403|2020-002962-15", "title": "Open-label Multi-site Extension Trial in Subjects Who Completed the DELTA 1 or DELTA 2 Trials", "enrollment": 600, "completionDate": "2023-09-01T00:00:00", "primaryCompletionDate": "2023-09-01T00:00:00", "results_first_submitted_date": null, "study_first_submitted_date": "2021-07-02T00:00:00", "startDate": "2021-08-23T00:00:00", "duration": 739, "study_phase": "Phase 3", "sponsor_collaborators": ["LEO Pharma"], "condition": ["Chronic Hand Eczema"], "outcomes": ["Number of treatment-emergent adverse events from baseline up to Week 38", "IGA-CHE score at each scheduled visit from baseline up to Week 36", "IGA-CHE score of 0 (clear) or 1 (almost clear) at each scheduled visit from baseline up to Week 36.", "HECSI score at each scheduled visit from baseline up to Week 36", "HECSI-75 at each scheduled visit from baseline up to Week 36", "HECSI-90 at each scheduled visit from baseline up to Week 36"], "interventions": ["Drug: Delgocitinib"], "meta_prim_outcome": "", "meta_time_frame": "" }
]
*/

const getSearchCriteria = () => {
    const localeCriteria = localStorage.getItem('searchCriteria');
    if (localeCriteria) {
        return JSON.parse(localeCriteria);
    }
    else {
        return {
            cond: "",
            term: "",
            phase: [
                {
                    id: "4", value: false, text: "Early Phase 1", coded: 0
                },
                {
                    id: "0", value: true, text: "Phase 1", coded: 1
                },
                {
                    id: "1", value: true, text: "Phase 2", coded: 2
                },
                {
                    id: "2", value: true, text: "Phase 3", coded: 3
                },
                {
                    id: "3", value: false, text: "Phase 4", coded: 4
                },
                {
                    id: "5", value: false, text: "Not Applicable", coded: 5
                }
            ],
            fund: [
                {
                    id: "0", value: false, text: "NIH", coded: "NIH"
                },
                {
                    id: "1", value: false, text: "Other U.S. Federal agency", coded: "FED"
                },
                {
                    id: "2", value: true, text: "Industry", coded: "INDUSTRY"
                },
                {
                    id: "3", value: false, text: "All others (individuals, universities, organizations)", coded: "OTHER"
                }
            ]
        }
    }
};
const initialState = {
    apiwarmedup: false,
    loading: false,
    searching: false,
    searchCount: undefined,
    loadingAC: false,
    searchDone: false /*true*/,
    searchCompleted: false,
    searchCriteria: getSearchCriteria(),
    conditions: [],
    toggleLists: "GraphsList",
    filterOpen: false,
    filteringCriteria: {},
    filteringSelected: {},
    allStudies: [] /*studies*/,
    excludedStudies: [],
    includedStudies: [] /*studies*/,
    shareUrl: "",
    search_error: "",
    resultsFetched: false,
    results: []
};

const addRemoveSelectedSearchCriteria = (id, type, searchCriteria) => {
    let transformedSelected = []
    searchCriteria[type].forEach((item, i) => {
        const object = { ...item }
        if (object.id === id) {
            object.value = !object.value
        }
        transformedSelected.push(object)
    })

    return transformedSelected;
}

export default function rootReducer(state = initialState, action) {
    switch (action.type) {
        case actions.RESET_SEARCH: {
            return { ...initialState }
        }
        case actions.TEST_API: {
            return {
                ...state,
                apiwarmedup: false
            };
        }
        case actions.API_TESTED: {
            return {
                ...state,
                apiwarmedup: true
            }
        }
        case actions.GETTING_CONDITION_LIST: {
            return {
                ...state,
                loadingAC: true
            }
        }
        case actions.UPDATE_STATE_WITH_SEARCH_CRITERIA: {
            let { searchTerms } = action.payload
            let searchCriteria = state.searchCriteria

            for (let [key, value] of Object.entries(searchTerms)) {
                if (key === "cond" || key === "term") {
                    searchCriteria[key] = value
                }
                else {
                    searchCriteria[key].map(item => value.includes(item.id) ? { ...item, value: true } : { ...item, value: false })
                }
            }

            return {
                ...state,
                searchCriteria: searchCriteria
            };
        }
        case actions.UPDATE_URL_PARAMS: {
            let { urlType, criteriaTxt } = action.payload
            let shareUrl = state.shareUrl
            if (urlType === "searchCriteria") {
                shareUrl = "?" + urlType + "=" + criteriaTxt;
            }
            else {
                if (!shareUrl.includes("&filteringCriteria")) {
                    shareUrl = shareUrl + "&" + urlType + "=" + criteriaTxt
                }
                else {
                    shareUrl = shareUrl.split('&')[0] + "&" + urlType + "=" + criteriaTxt
                }
            }
            return {
                ...state,
                shareUrl: shareUrl,
                searchCompleted: true,
            };
        }
        case actions.SET_INITIAL_FILTERS: {
            let { filteringCriteria, filteringSelected } = action.payload
            return {
                ...state,
                filteringCriteria: filteringCriteria,
                filteringSelected: filteringSelected
            }
        }
        case actions.GOT_CONDITION_LIST: {
            let { res } = action.payload
            return {
                ...state,
                loadingAC: false,
                conditions: res
            }
        }
        case actions.SEARCH_COUNT_RECEIVED: {
            let { count } = action.payload
            return {
                ...state,
                searchCount: count,
            }
        }
        case actions.TOGGLE_FILTER: {
            const filterState = !state.filterOpen
            return {
                ...state,
                filterOpen: filterState
            };
        }
        case actions.TOGGLE_TO_TYPE: {
            let { type } = action.payload
            return {
                ...state,
                toggleLists: type
            };
        }
        case actions.UPDATE_FILTER: {
            const { filteringSelected, filteredStudies } = action.payload
            return {
                ...state,
                filteringSelected: filteringSelected,
                includedStudies: filteredStudies
            };
        }
        case actions.RESET_FILTER: {

            const startDate = state.filteringCriteria["startDate"]

            const filteringSelected = {
                startDate: startDate,
                study_phase: [],
                sponsor_collaborators: [],
                condition: [],
                interventions: [],
                title: [],
                studyId: [],
                outcomes: []
            }

            return {
                ...state,
                filteringSelected: filteringSelected,
                includedStudies: state.allStudies
            };
        }
        case actions.SEARCH_RECEIVED: {
            const { res } = action.payload;
            const all = state.allStudies.concat(res)

            return {
                ...state,
                loading: (res.length >= 100) ? true : false,
                includedStudies: all,
                allStudies: all,
                searchDone: true,
            }
        }
        case actions.SEARCH_SUBMIT: {
            return {
                ...state,
                loading: true,
                searching: true,
                filteringCriteria: {
                    ...state.filteringCriteria,
                    condition: [],
                    interventions: [],
                    sponsor_collaborators: [],
                    studyId: [],
                    study_phase: [],
                    startDate: ""
                },
                allStudies: [],
                excludedStudies: [],
                includedStudies: [],

            };
        }
        case actions.SET_SEARCH_CRITERIA_VALUE: {
            const { id, value } = action.payload;

            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    [id]: value
                }
            };
        }
        case actions.SEARCH_PHASE_SELECTED: {
            const { id, type } = action.payload;

            const transformedSelected = addRemoveSelectedSearchCriteria(id, type, state.searchCriteria);

            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    [type]: transformedSelected
                }
            }
        }
        case actions.SEARCH_FUND_SELECTED: {
            const { id, type } = action.payload;

            const transformedSelected = addRemoveSelectedSearchCriteria(id, type, state.searchCriteria);

            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    [type]: transformedSelected
                }
            }
        }
        case actions.API_ERROR: {
            const { type, message } = action.payload;
            return {
                ...state,
                [type]: message,
                loading: false,
            }
        }

        case actions.GET_RESULT_STARTED: {
            return {
                ...state,
                resultsFetched: false,
                results: [],
            };
        }

        case actions.GET_RESULTS_FETCHED: {
            const { res } = action.payload;
            return {
                ...state,
                resultsFetched: true,
                results: res,
            };
        }

        default:
            return { ...state }

    }

}

